module.exports = __webpack_public_path__ + "static/kamisato-ayato-button-993c0943e7db2003e63b48a9e6271c3b.webp";